import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTotem, setCidade } from '../../api/apiFactory';
import { fetchLimparCookie, fetchNomeCidade } from '../../api/endpoints';
import { definirCidade, fetchConfiguracoesCidade, selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import { resetarModais, selectModal } from '../../app/slices/modalSlice';
import AppHeader from '../../components/AppHeader/AppHeader';
import FormularioAlterarCadastro from '../../components/FormularioAlterarCadastro/FormularioAlterarCadastro';
import FormularioUsuarioCadastro from '../../components/FormularioUsuarioCadastro/FormularioUsuarioCadastro';
import ModalBairro from '../../components/ModalBairro/ModalBairro';
import ModalComoSoube from '../../components/ModalComoSoube/ModalComoSoube';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalEscolaridade from '../../components/ModalEscolaridade/ModalEscolaridade';
import ModalEscolhaLoginTotem from '../../components/ModalEscolhaLoginTotem/ModalEscolhaLoginTotem';
import ModalLogin from '../../components/ModalLogin/ModalLogin';
import ModalLoginTotem from '../../components/ModalLoginTotem/ModalLoginTotem';
import ModalSexo from '../../components/ModalSexo/ModalSexo';
import { AppBody, AppFragment } from '../../styles/base';

const VisualizarUsuario = () => {
  const dadosModal = useSelector(selectModal);
  const dadosLogin = useSelector(selectLogin);

  const dispatch = useDispatch();

  window.onload = () => {
    dispatch(resetarModais());
  };

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  if (cookieId) {
    const escolherCidadeCookie = async (Id, Campo) => {
      setCidade({ Id, Campo });
      dispatch(definirCidade({
        idCidade: Id,
        nomeCidade: Campo,
      }));
      await fetchLimparCookie();
      await dispatch(fetchConfiguracoesCidade());
    };

    dispatch(desfazerConexao());
    fetchNomeCidade(cookieId).then((nomeCidade) => escolherCidadeCookie(cookieId, nomeCidade));
  }

  if (dadosLogin.data) {
    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        {dadosModal.modalLoginTotem === 'aberto' && (<ModalLoginTotem />)}
        {dadosModal.modalEscolhaLoginTotem === 'aberto' && (<ModalEscolhaLoginTotem />)}
        {dadosModal.modalBairro === 'aberto' && (<ModalBairro />)}
        {dadosModal.modalSexo === 'aberto' && (<ModalSexo />)}
        {dadosModal.modalEscolaridade === 'aberto' && (<ModalEscolaridade />)}
        {dadosModal.modalComoSoube === 'aberto' && (<ModalComoSoube />)}
        <AppHeader />
        <AppBody totem={getTotem() === 'true'} desfoque={dadosModal.desfoque} className="controle-fundo">
          <FormularioAlterarCadastro />
        </AppBody>
      </AppFragment>
    );
  }

  return (
    <AppFragment
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          dispatch(resetarModais());
        }
      }}
      tabIndex="0"
    >
      {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
      {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
      {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
      {dadosModal.modalLoginTotem === 'aberto' && (<ModalLoginTotem />)}
      {dadosModal.modalEscolhaLoginTotem === 'aberto' && (<ModalEscolhaLoginTotem />)}
      {dadosModal.modalBairro === 'aberto' && (<ModalBairro />)}
      {dadosModal.modalSexo === 'aberto' && (<ModalSexo />)}
      {dadosModal.modalEscolaridade === 'aberto' && (<ModalEscolaridade />)}
      {dadosModal.modalComoSoube === 'aberto' && (<ModalComoSoube />)}
      <AppHeader />
      <AppBody desfoque={dadosModal.desfoque} className="controle-fundo">
        <FormularioUsuarioCadastro />
      </AppBody>
    </AppFragment>

  );
};

export default VisualizarUsuario;
